import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList
} from 'recharts';
import { Box } from '@mui/material';

/**
 * Componente personalizado para dibujar las barras como "cápsulas" redondeadas
 */
const RoundedBar = (props) => {
    const { fill, x, y, width, height } = props;
    return <rect x={x} y={y} width={width} height={height} rx={width / 2} ry={width / 2} fill={fill} />;
};

const ReportsProcessCompChart = ({ data }) => {
  // Configuración de espaciado fijo
  const barWidth = 25; // Tamaño de la barra
  const gapBetweenGroups = 60; // Distancia fija entre comparaciones
  const totalWidth = data.length * gapBetweenGroups; // Ancho total calculado

  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      p: 1,
      overflowX: 'auto',
      overflowY: 'hidden',
      '&::-webkit-scrollbar': { height: '8px' },
      '&::-webkit-scrollbar-thumb': { backgroundColor: '#e0e0e0', borderRadius: '10px' }
    }}>
      {/* Usamos un div intermedio con el ancho calculado para forzar el scroll
          mientras mantenemos el ResponsiveContainer para el alto
      */}
      <div style={{ width: totalWidth, height: '100%', minWidth: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 10, left: 20, bottom: 5 }}
            barGap={-barWidth+7} // Superposición parcial: la barra actual sobre la media
            barCategoryGap={gapBetweenGroups - barWidth} // Controla el espacio entre grupos
          >
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#9e9e9e', fontSize: 12 }}
            />
            <YAxis hide domain={[0, 12]} />
            <Tooltip cursor={{fill: 'transparent'}} />

            {/* Barra de Media (Fondo gris) */}
            <Bar
              dataKey="media"
              shape={<RoundedBar />}
              fill="#f0f0f0"
              barSize={barWidth}
            >
              <LabelList dataKey="media" position="top" style={{ fill: '#bdbdbd', fontSize: '14px' }} />
            </Bar>

            {/* Barra Actual (Color dinámico) */}
            <Bar
              dataKey="actual"
              shape={<RoundedBar />}
              barSize={barWidth}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} stroke={entry.color} strokeWidth={2} fillOpacity={0.1} />
              ))}
              <LabelList
                  dataKey="actual"
                  position="insideBottom"
                  offset={10}
                  style={{ fill: '#757575', fontWeight: 'bold' }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Box>
  );
};

export default ReportsProcessCompChart;